import React from "react";
import { useTranslation } from "react-i18next";
import { useNetworkStatus } from "../hooks/useNetworkStatus";

// eslint-disable-next-line react/prop-types
const NetworkBanner = ({ retrying = false }) => {
    const { t } = useTranslation();
    const { online, slow } = useNetworkStatus();
    if (online && !slow && !retrying) return null;
    const text = !online ? t("network.offline") : retrying ? t("network.retrying") : t("network.slow");
    return (
        <div role="status" style={{ background: !online ? "#fff3cd" : "#e7f5ff", color: "#333", border: "1px solid " + (!online ? "#ffb703" : "#00b8e6"), borderRadius: "8px", padding: "10px 14px", margin: "12px 0", fontSize: "14px" }}>
            {text}
        </div>
    );
};

export default NetworkBanner;
